export default __webpack_public_path__ + "static/media/autro-master.73fd2cfa.jpg";